module.exports = __webpack_public_path__ + "4805145ae5095d5156e5.worklet.js";